import { ItemDeliveryStatus } from '@/cowboy/EnumTypes'

export const IsDeliveredStatuses = Object.freeze([
  ItemDeliveryStatus.DELIVERED,
  ItemDeliveryStatus.OPEN,
  ItemDeliveryStatus.CLICK,
  ItemDeliveryStatus.SPAMREPORT
])

export const IsPendingStatuses = Object.freeze([
  ItemDeliveryStatus.PROCESSED,
  ItemDeliveryStatus.DEFERRED
])

export const IsFailedStatuses = Object.freeze([
  ItemDeliveryStatus.BOUNCE,
  ItemDeliveryStatus.BLOCKED,
  ItemDeliveryStatus.DROPPED
])
